// extracted by mini-css-extract-plugin
export default {"title":"RelatedPackages_title__t-663","cardsWrapper":"RelatedPackages_cardsWrapper__RNBAP"};